export default __webpack_public_path__ + "static/media/seven.286f1383.jpg";